@if (state().visible) {
  <div class="srdl-scrim" role="dialog" aria-modal="true" aria-live="polite">
    <div class="srdl-modal">

      @if (!state().done) {
        <!-- ===== Loading body ===== -->
        <div class="srdl-body">
          <div class="srdl-tstage">
            <div class="srdl-doc"
                 [class.srdl-doc--split]="state().config?.split"
                 [class.srdl-doc--settle]="docSettled()">

              @if (state().config?.split) {
                <div class="srdl-doc__sheet2"></div>
              }

              <div class="srdl-doc__hd">
                <div class="srdl-doc__logo"></div>
                <div class="srdl-doc__cap"></div>
              </div>

              @for (i of docLines; track i; let idx = $index) {
                <div class="srdl-doc__ln"
                     [class.srdl-doc__ln--show]="idx < linesRevealed()"
                     [attr.data-w]="i"></div>
              }

              @if (state().config?.stamp) {
                <div class="srdl-stamp" [class.srdl-stamp--drop]="stampDrop()">
                  <div class="srdl-stamp__bars">
                    @for (on of stampBars; track $index) {
                      <i [class.on]="on"></i>
                    }
                  </div>
                  <div class="srdl-stamp__lbl">TIMBRE SII</div>
                </div>
              }
            </div>
          </div>

          <div class="srdl-status">
            <div class="srdl-status__l">{{ statusLabel() }}</div>
            <div class="srdl-status__s">{{ stepCaption() }}</div>
          </div>

          <!-- Barra de progreso SIEMPRE indeterminada (sin porcentaje fake).
               Antes pintaba segmentos done/active/pending que avanzaban con
               timer interno — daba la impresión de "100% loading bar" que
               se quedaba en 100% sin completarse cuando el backend tardaba.
               Ahora es honesta: animación CSS que no promete progreso real. -->
          <div class="srdl-track srdl-track--indet">
            <i></i>
          </div>
        </div>

        <div class="srdl-foot">
          <lucide-angular [img]="icons.Lock" [size]="13"></lucide-angular>
          No cierre esta ventana
        </div>
      } @else if (state().result; as result) {
        <!-- ===== Done · OK ===== -->
        <div class="srdl-ok">
          <div class="srdl-ok__check"
               [class.srdl-ok__check--draft]="result.draft">
            <lucide-angular
              [img]="result.draft ? icons.Save : icons.Check"
              [size]="30"></lucide-angular>
          </div>

          <div class="srdl-ok__t">{{ result.title }}</div>

          @if (result.pills && result.pills.length > 0) {
            <div class="srdl-ok__folio">
              @for (p of result.pills; track p.l) {
                <div class="srdl-ok__pill">
                  <div class="srdl-ok__pill-l">{{ p.l }}</div>
                  <div class="srdl-ok__pill-v"
                       [class.srdl-ok__pill-v--accent]="p.accent">
                    {{ p.v }}
                  </div>
                </div>
              }
            </div>
          }

          @if (result.navigateTo) {
            <button type="button" class="srdl-ok__btn" (click)="onPrimaryCta()">
              {{ result.ctaLabel || 'Ver documento' }}
              <lucide-angular [img]="icons.ArrowRight" [size]="15"></lucide-angular>
            </button>
          } @else {
            <button type="button" class="srdl-ok__btn" (click)="onClose()">
              Cerrar
            </button>
          }
        </div>
      }
    </div>
  </div>
}
